module.exports = __webpack_public_path__ + "img/stolik-4.b5cc9340.jpg";